export const cardSGroups = [
    "orozco_employee_profile_read",
    "orozco_employee_profile_read_employee",
        "employee_read_id",
        "employee_read_full_name",
        "employee_read_is_in_lounge",
        "employee_read_is_eating"
];